// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!./cms-design-tokens.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./cms-dialog.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  margin: 0;
  padding: 0;
  height: 100%;
  min-height: 100vh;
}

body {
  font-family: var(--cms-mfe-font-family);
  font-size: var(--cms-mfe-font-size);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.cms-mfe-root {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100vh;
  height: 100%;
  font-family: var(--cms-mfe-font-family);
  font-size: var(--cms-mfe-font-size);
  line-height: 1.45;
  color: var(--cms-mfe-color-text);
  background: var(--cms-mfe-color-surface-muted);
}

/* ── Shell layout ─────────────────────────────────────────────── */

.cms-mfe-shell {
  display: flex;
  flex: 1;
  min-height: 100vh;
  height: 100%;
  gap: 0;
  align-items: stretch;
}

.cms-mfe-shell__main {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cms-mfe-shell__outlet {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: var(--cms-mfe-space-lg);
  max-width: 100%;
  box-sizing: border-box;
}

.cms-mfe-shell[data-cms-embedded='true'] .cms-mfe-shell__outlet {
  padding: var(--cms-mfe-space-md) var(--cms-mfe-space-lg);
}

/* ── Sidebar navigation ───────────────────────────────────────── */

.cms-mfe-shell-nav {
  flex-shrink: 0;
  box-sizing: border-box;
}

.cms-mfe-shell-nav--sidebar {
  display: flex;
  flex-direction: column;
  width: var(--cms-mfe-nav-width);
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  position: sticky;
  top: 0;
  align-self: flex-start;
  padding: 0;
  overflow: hidden;
  background: var(--cms-mfe-color-surface-elevated);
  border-right: 1px solid var(--cms-mfe-color-border);
  box-shadow: 1px 0 0 rgba(15, 23, 42, 0.04), 4px 0 16px rgba(15, 23, 42, 0.04);
  transition: width var(--cms-mfe-nav-transition);
}

.cms-mfe-shell-nav--sidebar.cms-mfe-shell-nav--collapsed {
  width: var(--cms-mfe-nav-width-collapsed);
}

.cms-mfe-shell-nav--tabs {
  width: 100%;
  height: auto;
  min-height: 0;
  max-height: none;
  position: static;
  border-right: none;
  border-bottom: 1px solid var(--cms-mfe-color-border);
  padding: 0 var(--cms-mfe-space-md);
  box-shadow: var(--cms-mfe-shadow-nav);
}

.cms-mfe-shell[data-cms-embedded='true'] {
  min-height: 100vh;
}

.cms-mfe-shell-nav__brand {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  flex-shrink: 0;
  padding: 1rem 1rem 0.875rem;
  border-bottom: 1px solid var(--cms-mfe-color-border);
  background: var(--cms-mfe-color-surface-elevated);
  transition: padding var(--cms-mfe-nav-transition);
}

.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__brand {
  justify-content: center;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.cms-mfe-shell-nav--tabs .cms-mfe-shell-nav__brand {
  display: none;
}

.cms-mfe-shell-nav__brand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: var(--cms-mfe-radius-sm);
  background: linear-gradient(135deg, var(--cms-mfe-color-primary) 0%, var(--cms-mfe-color-accent) 100%);
  color: var(--cms-mfe-color-text-inverse);
  font-size: 0.9375rem;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25);
  flex-shrink: 0;
}

.cms-mfe-shell-nav__brand-label {
  font-weight: 600;
  font-size: 0.875rem;
  letter-spacing: -0.02em;
  color: var(--cms-mfe-color-text);
  white-space: nowrap;
  overflow: hidden;
  transition:
    opacity var(--cms-mfe-nav-transition),
    max-width var(--cms-mfe-nav-transition);
  max-width: 12rem;
}

.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__brand-label {
  opacity: 0;
  max-width: 0;
}

.cms-mfe-shell-nav__list {
  list-style: none;
  margin: 0;
  padding: 0.625rem 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: var(--cms-mfe-color-border-strong) transparent;
}

.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__list {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.cms-mfe-shell-nav__list::-webkit-scrollbar {
  width: 4px;
}

.cms-mfe-shell-nav__list::-webkit-scrollbar-thumb {
  background: var(--cms-mfe-color-border-strong);
  border-radius: 4px;
}

.cms-mfe-shell-nav--tabs .cms-mfe-shell-nav__list {
  flex: initial;
  flex-direction: row;
  gap: 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0;
}

.cms-mfe-shell-nav__item {
  margin: 0;
}

.cms-mfe-shell-nav__link {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 0.75rem;
  border-radius: var(--cms-mfe-radius-sm);
  color: var(--cms-mfe-color-text-muted);
  text-decoration: none;
  font-size: 0.8125rem;
  font-weight: 500;
  border-left: 3px solid transparent;
  transition:
    background var(--cms-mfe-transition),
    color var(--cms-mfe-transition),
    border-color var(--cms-mfe-transition),
    padding var(--cms-mfe-nav-transition);
  white-space: nowrap;
}

.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__link {
  justify-content: center;
  gap: 0;
  padding: 0.625rem 0.5rem;
  border-left-color: transparent;
}

.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__link--active,
.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__link.cms-mfe-shell-nav__link--active {
  border-left-color: transparent;
  box-shadow: inset 3px 0 0 var(--cms-mfe-color-primary);
}

.cms-mfe-shell-nav--tabs .cms-mfe-shell-nav__link {
  border-radius: 0;
  border-left: none;
  border-bottom: 2px solid transparent;
  padding: 0.5rem 0.75rem;
}

.cms-mfe-shell-nav__link:hover {
  background: var(--cms-mfe-color-primary-soft);
  color: var(--cms-mfe-color-primary);
}

.cms-mfe-shell-nav__link--active,
.cms-mfe-shell-nav__link.cms-mfe-shell-nav__link--active {
  background: var(--cms-mfe-color-primary-soft);
  color: var(--cms-mfe-color-primary);
  border-left-color: var(--cms-mfe-color-primary);
  font-weight: 600;
}

.cms-mfe-shell-nav--tabs .cms-mfe-shell-nav__link--active {
  background: transparent;
  border-left-color: transparent;
  border-bottom-color: var(--cms-mfe-color-primary);
}

.cms-mfe-shell-nav__link-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.375rem;
  font-size: 0.9375rem;
  opacity: 0.9;
  flex-shrink: 0;
}

.cms-mfe-shell-nav__link--active .cms-mfe-shell-nav__link-icon {
  opacity: 1;
}

.cms-mfe-shell-nav__link-label {
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  transition:
    opacity var(--cms-mfe-nav-transition),
    max-width var(--cms-mfe-nav-transition);
  max-width: 12rem;
}

.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__link-label {
  opacity: 0;
  max-width: 0;
}

.cms-mfe-shell-nav__footer {
  flex-shrink: 0;
  padding: 0.5rem;
  border-top: 1px solid var(--cms-mfe-color-border);
  background: var(--cms-mfe-color-surface-muted);
}

.cms-mfe-shell-nav__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  min-height: 2.25rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--cms-mfe-color-border);
  border-radius: var(--cms-mfe-radius-sm);
  background: var(--cms-mfe-color-surface-elevated);
  color: var(--cms-mfe-color-text-muted);
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 500;
  cursor: pointer;
  transition:
    background var(--cms-mfe-transition),
    color var(--cms-mfe-transition),
    border-color var(--cms-mfe-transition),
    padding var(--cms-mfe-nav-transition);
}

.cms-mfe-shell-nav__toggle:hover {
  background: var(--cms-mfe-color-primary-soft);
  color: var(--cms-mfe-color-primary);
  border-color: rgba(59, 130, 246, 0.25);
}

.cms-mfe-shell-nav__toggle-icon {
  font-size: 0.875rem;
  flex-shrink: 0;
}

.cms-mfe-shell-nav__toggle-label {
  white-space: nowrap;
  overflow: hidden;
  transition:
    opacity var(--cms-mfe-nav-transition),
    max-width var(--cms-mfe-nav-transition);
  max-width: 8rem;
}

.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__toggle {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__toggle-label {
  opacity: 0;
  max-width: 0;
}

/* ── PrimeReact — compact density ─────────────────────────────── */

.cms-mfe-root .p-breadcrumb {
  background: transparent;
  border: none;
  padding: 0 0 var(--cms-mfe-space-md);
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-breadcrumb .p-menuitem-link {
  border-radius: var(--cms-mfe-radius-sm);
  padding: 0.2rem 0.35rem;
}

.cms-mfe-root .p-panel,
.cms-mfe-root .cms-mfe-content-card {
  background: var(--cms-mfe-color-surface-elevated);
  border: 1px solid var(--cms-mfe-color-border);
  border-radius: var(--cms-mfe-radius-md);
  box-shadow: var(--cms-mfe-shadow-card);
}

.cms-mfe-root .p-button {
  padding: 0.3125rem 0.625rem;
  font-size: var(--cms-mfe-font-size-sm);
  font-weight: 500;
  line-height: 1.25;
  border-radius: var(--cms-mfe-radius-sm);
}

.cms-mfe-root .p-button .p-button-icon {
  font-size: 0.8125rem;
}

.cms-mfe-root .p-button.p-button-icon-only {
  width: var(--cms-mfe-control-height-sm);
  height: var(--cms-mfe-control-height-sm);
  padding: 0;
}

.cms-mfe-root .p-button.p-button-sm {
  padding: 0.25rem 0.5rem;
  font-size: var(--cms-mfe-font-size-xs);
}

.cms-mfe-root .p-button.p-button-sm.p-button-icon-only {
  width: 1.625rem;
  height: 1.625rem;
}

/* ── Form controls — unified input / dropdown / calendar height ─ */

.cms-mfe-root .p-inputtext,
.cms-mfe-root .p-inputnumber-input {
  box-sizing: border-box;
  height: var(--cms-mfe-input-height);
  min-height: var(--cms-mfe-input-height);
  padding: var(--cms-mfe-input-padding-y) var(--cms-mfe-input-padding-x);
  font-size: var(--cms-mfe-input-font-size);
  line-height: var(--cms-mfe-input-line-height);
  border-radius: var(--cms-mfe-radius-sm);
}

.cms-mfe-root .p-inputtextarea {
  box-sizing: border-box;
  padding: var(--cms-mfe-input-padding-y) var(--cms-mfe-input-padding-x);
  font-size: var(--cms-mfe-input-font-size);
  line-height: var(--cms-mfe-input-line-height);
  border-radius: var(--cms-mfe-radius-sm);
}

.cms-mfe-root .p-dropdown,
.cms-mfe-root .p-multiselect {
  box-sizing: border-box;
  height: var(--cms-mfe-input-height);
  min-height: var(--cms-mfe-input-height);
  border-radius: var(--cms-mfe-radius-sm);
  align-items: stretch;
}

.cms-mfe-root .p-dropdown .p-dropdown-label,
.cms-mfe-root .p-multiselect .p-multiselect-label {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 0;
  padding: var(--cms-mfe-input-padding-y) var(--cms-mfe-input-padding-x);
  font-size: var(--cms-mfe-input-font-size);
  line-height: var(--cms-mfe-input-line-height);
}

.cms-mfe-root .p-dropdown .p-dropdown-label.p-placeholder,
.cms-mfe-root .p-multiselect .p-multiselect-label.p-placeholder {
  color: var(--cms-mfe-color-text-muted);
}

.cms-mfe-root .p-dropdown .p-dropdown-trigger,
.cms-mfe-root .p-multiselect .p-multiselect-trigger {
  width: var(--cms-mfe-input-height);
  flex-shrink: 0;
}

.cms-mfe-root .p-dropdown .p-dropdown-trigger .p-dropdown-trigger-icon,
.cms-mfe-root .p-multiselect .p-multiselect-trigger .p-multiselect-trigger-icon {
  font-size: 0.75rem;
}

.cms-mfe-root .p-multiselect .p-multiselect-token {
  padding: 0.125rem 0.375rem;
  font-size: var(--cms-mfe-font-size-xs);
  margin-right: 0.25rem;
}

.cms-mfe-root .p-calendar {
  display: inline-flex;
  width: 100%;
  max-width: 100%;
}

.cms-mfe-root .p-calendar.p-inputwrapper,
.cms-mfe-root .p-calendar-w-btn {
  height: var(--cms-mfe-input-height);
  min-height: var(--cms-mfe-input-height);
  align-items: stretch;
}

.cms-mfe-root .p-calendar .p-inputtext {
  box-sizing: border-box;
  flex: 1 1 auto;
  width: 1%;
  height: 100%;
  min-height: 0;
  padding: var(--cms-mfe-input-padding-y) var(--cms-mfe-input-padding-x);
  font-size: var(--cms-mfe-input-font-size);
  line-height: var(--cms-mfe-input-line-height);
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.cms-mfe-root .p-calendar .p-datepicker-trigger,
.cms-mfe-root .p-calendar .p-button.p-datepicker-trigger {
  box-sizing: border-box;
  width: var(--cms-mfe-input-height);
  height: var(--cms-mfe-input-height);
  min-height: var(--cms-mfe-input-height);
  padding: 0;
  flex-shrink: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.cms-mfe-root .p-calendar .p-datepicker-trigger .p-button-icon,
.cms-mfe-root .p-calendar .p-button.p-datepicker-trigger .p-button-icon {
  font-size: 0.8125rem;
}

.cms-mfe-root .p-calendar:not(.p-calendar-w-btn) .p-inputtext {
  border-radius: var(--cms-mfe-radius-sm);
}

.cms-mfe-root .p-field .p-dropdown,
.cms-mfe-root .p-field .p-multiselect,
.cms-mfe-root .p-field .p-calendar,
.cms-mfe-root .p-field .p-inputtext {
  width: 100%;
}

.cms-mfe-root .w-full.p-dropdown,
.cms-mfe-root .w-full.p-multiselect,
.cms-mfe-root .w-full.p-calendar,
.cms-mfe-root .w-full.p-inputtext {
  width: 100%;
}

.cms-mfe-root .p-datatable {
  border-radius: var(--cms-mfe-radius-md);
  overflow: hidden;
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-datatable .p-datatable-header {
  background: var(--cms-mfe-color-surface-elevated);
  border: 1px solid var(--cms-mfe-color-border);
  border-bottom: none;
  border-radius: var(--cms-mfe-radius-md) var(--cms-mfe-radius-md) 0 0;
  padding: var(--cms-mfe-space-md) var(--cms-mfe-space-lg);
}

.cms-mfe-root .p-datatable .p-datatable-wrapper {
  border: 1px solid var(--cms-mfe-color-border);
  border-radius: 0 0 var(--cms-mfe-radius-md) var(--cms-mfe-radius-md);
  overflow: hidden;
}

.cms-mfe-root .p-datatable .p-datatable-thead > tr > th {
  background: var(--cms-mfe-color-surface-muted);
  color: var(--cms-mfe-color-text-muted);
  font-weight: 600;
  font-size: var(--cms-mfe-font-size-xs);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-color: var(--cms-mfe-color-border);
  padding: 0.4375rem 0.625rem;
}

.cms-mfe-root .p-datatable .p-datatable-tbody > tr {
  transition: background var(--cms-mfe-transition);
}

.cms-mfe-root .p-datatable .p-datatable-tbody > tr:hover {
  background: var(--cms-mfe-color-primary-soft);
}

.cms-mfe-root .p-datatable .p-datatable-tbody > tr > td {
  border-color: var(--cms-mfe-color-border);
  font-size: var(--cms-mfe-font-size-sm);
  padding: 0.4375rem 0.625rem;
  vertical-align: middle;
}

.cms-mfe-root .p-datatable .p-datatable-tbody > tr:nth-child(even) {
  background: rgba(248, 250, 252, 0.6);
}

.cms-mfe-root .p-datatable .p-sortable-column .p-sortable-column-icon {
  font-size: 0.6875rem;
}

.cms-mfe-root .p-paginator {
  border: 1px solid var(--cms-mfe-color-border);
  border-top: none;
  border-radius: 0 0 var(--cms-mfe-radius-md) var(--cms-mfe-radius-md);
  background: var(--cms-mfe-color-surface-elevated);
  padding: 0.25rem 0.375rem;
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-paginator .p-paginator-element,
.cms-mfe-root .p-paginator .p-paginator-pages .p-paginator-page {
  min-width: 1.625rem;
  height: 1.625rem;
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-paginator .p-dropdown {
  height: 1.625rem;
  min-height: 1.625rem;
}

.cms-mfe-root .p-paginator .p-dropdown .p-dropdown-label {
  padding: 0.125rem 0.375rem;
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-paginator .p-dropdown .p-dropdown-trigger {
  width: 1.625rem;
}

.cms-mfe-root .p-tag {
  border-radius: 999px;
  font-size: var(--cms-mfe-font-size-xs);
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 0.125rem 0.4375rem;
}

.cms-mfe-root .group-header {
  margin: var(--cms-mfe-space-md) 0 var(--cms-mfe-space-sm);
  border-bottom: 1px solid var(--cms-mfe-color-border);
  padding-bottom: var(--cms-mfe-space-xs);
  color: var(--cms-mfe-color-text);
  font-weight: 600;
  font-size: var(--cms-mfe-font-size);
}

.cms-mfe-root .p-field {
  margin-bottom: 0.5rem;
}

.cms-mfe-root .p-field > label,
.cms-mfe-root label {
  display: block;
  margin-bottom: var(--cms-mfe-space-xs);
  font-size: var(--cms-mfe-font-size-sm);
  font-weight: 500;
  color: var(--cms-mfe-color-text-muted);
}

.cms-mfe-root .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 0.5rem 0.75rem;
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-tabview .p-tabview-nav {
  border-radius: var(--cms-mfe-radius-md) var(--cms-mfe-radius-md) 0 0;
  background: var(--cms-mfe-color-surface-elevated);
}

.cms-mfe-root .p-tabview .p-tabview-panels {
  background: var(--cms-mfe-color-surface-elevated);
  border: 1px solid var(--cms-mfe-color-border);
  border-top: none;
  border-radius: 0 0 var(--cms-mfe-radius-md) var(--cms-mfe-radius-md);
  padding: var(--cms-mfe-space-md);
}

.cms-mfe-root .p-accordion .p-accordion-header .p-accordion-header-link {
  padding: 0.5rem 0.75rem;
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-accordion .p-accordion-content {
  padding: var(--cms-mfe-space-md);
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-card {
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-card .p-card-body {
  padding: var(--cms-mfe-space-md);
}

.cms-mfe-root .p-card .p-card-title {
  font-size: var(--cms-mfe-font-size);
  margin-bottom: var(--cms-mfe-space-sm);
}

.cms-mfe-root .p-skeleton {
  border-radius: var(--cms-mfe-radius-sm);
}

.cms-mfe-root .p-tooltip .p-tooltip-text {
  font-size: var(--cms-mfe-font-size-xs);
  padding: 0.25rem 0.4375rem;
}

.cms-mfe-root .p-confirm-popup {
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-mfe-root .p-confirm-popup .p-confirm-popup-footer .p-button {
  padding: 0.25rem 0.5rem;
}

/* Advanced search panels */
.cms-mfe-root .cms-mfe-advanced-search {
  background: var(--cms-mfe-color-surface-muted);
  border: 1px solid var(--cms-mfe-color-border);
  border-radius: var(--cms-mfe-radius-md);
  padding: var(--cms-mfe-space-md);
  margin-top: var(--cms-mfe-space-md);
}

/* PrimeFlex grid inside CMS — tighter gutters */
.cms-mfe-root .grid {
  margin-right: -0.25rem;
  margin-left: -0.25rem;
  margin-top: -0.25rem;
}

.cms-mfe-root .grid > [class*='col'] {
  padding: 0.25rem;
}

.cms-mfe-providers-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

/* ── Toast ────────────────────────────────────────────────────── */

.cms-mfe-toast-host.p-toast {
  width: min(24rem, calc(100vw - 1.5rem));
  max-width: 100%;
}

.cms-mfe-toast-host .p-toast-message {
  margin: 0 0 0.5rem;
  border-radius: var(--cms-mfe-radius-sm);
  box-shadow: var(--cms-mfe-shadow-md);
  backdrop-filter: blur(4px);
}

.cms-mfe-toast-host .p-toast-message-error {
  background: var(--cms-mfe-color-surface-elevated);
  border-left: 3px solid var(--cms-mfe-color-danger);
  outline: none;
}

.cms-mfe-toast-host .p-toast-message-error .p-toast-summary {
  font-weight: 600;
  font-size: var(--cms-mfe-font-size);
  color: var(--cms-mfe-color-text);
}

.cms-mfe-toast-host .p-toast-message-error .p-toast-detail {
  color: var(--cms-mfe-color-text-muted);
  font-size: var(--cms-mfe-font-size-sm);
  margin-top: 0.25rem;
  line-height: 1.4;
  white-space: pre-wrap;
}

.cms-mfe-toast-host .p-toast-icon-close:hover {
  background: var(--cms-mfe-color-primary-soft);
}

/* ── Standalone / iframe roots ────────────────────────────────── */

.cms-mfe-standalone-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  box-sizing: border-box;
  background: var(--cms-mfe-color-surface-muted, #f4f6f9);
}

.cms-mfe-iframe-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  box-sizing: border-box;
}

.cms-mfe-iframe-root > *,
.cms-mfe-standalone-root > * {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

/* ── Detail field pairs (OutPutPair) ─────────────────────────── */

.cms-mfe-root .cms-output-pair__label-col,
.cms-mfe-root .cms-output-pair__value-col {
  min-width: 0;
  margin-bottom: 0;
}

.cms-mfe-root .cms-output-pair__label,
.cms-mfe-root .cms-output-pair__value {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  min-height: 1.625rem;
  padding: 0.25rem 0.5rem;
  line-height: 1.3;
  border: 1px solid var(--cms-mfe-color-border);
  min-width: 0;
}

.cms-mfe-root .cms-output-pair__label {
  height: 100%;
  background: var(--cms-mfe-color-surface-muted);
  color: var(--cms-mfe-color-text-muted);
  font-size: var(--cms-mfe-font-size-xs);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  border-radius: var(--cms-mfe-radius-sm) 0 0 var(--cms-mfe-radius-sm);
  border-right: none;
}

.cms-mfe-root .cms-output-pair__value {
  height: 100%;
  background: var(--cms-mfe-color-surface-elevated);
  color: var(--cms-mfe-color-text);
  font-size: var(--cms-mfe-font-size-sm);
  word-break: break-word;
  border-radius: 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0;
}

.cms-mfe-root .cms-output-pair__value--empty {
  color: var(--cms-mfe-color-text-muted);
}

.cms-mfe-root .cms-output-pair__value--custom {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

@media (max-width: 767px) {
  .cms-mfe-root .cms-output-pair__label {
    border-right: 1px solid var(--cms-mfe-color-border);
    border-radius: var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0 0;
    border-bottom: none;
  }

  .cms-mfe-root .cms-output-pair__value {
    border-radius: 0 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm);
    margin-bottom: var(--cms-mfe-space-xs);
  }
}

.cms-iframe-shell {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 100vh;
  padding: var(--cms-mfe-space-xl) var(--cms-mfe-space-lg);
  text-align: center;
  color: var(--cms-mfe-color-text-muted, #64748b);
  font-family: var(--cms-mfe-font-family);
  gap: var(--cms-mfe-space-md);
  font-size: var(--cms-mfe-font-size-sm);
}

.cms-iframe-shell__spinner {
  font-size: 1.5rem;
  color: var(--cms-mfe-color-primary, #3b82f6);
}

.cms-iframe-shell--error {
  color: var(--cms-mfe-color-danger, #dc2626);
}

.cms-iframe-shell__hint {
  margin-top: var(--cms-mfe-space-sm);
  font-size: var(--cms-mfe-font-size-sm);
  color: var(--cms-mfe-color-text-muted, #94a3b8);
}
`, "",{"version":3,"sources":["webpack://./src/cms/cms-app.css"],"names":[],"mappings":"AAGA;;;EAGE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,uCAAuC;EACvC,mCAAmC;EACnC,iBAAiB;EACjB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA,oEAAoE;;AAEpE;EACE,aAAa;EACb,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,MAAM;EACN,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA,oEAAoE;;AAEpE;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,iDAAiD;EACjD,mDAAmD;EACnD,6EAA6E;EAC7E,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oDAAoD;EACpD,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,2BAA2B;EAC3B,oDAAoD;EACpD,iDAAiD;EACjD,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,sGAAsG;EACtG,wCAAwC;EACxC,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB;;2CAEyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,uCAAuC;EACvC,sCAAsC;EACtC,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC;;;;yCAIuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,MAAM;EACN,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;EAC9B,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;;EAEE,6CAA6C;EAC7C,mCAAmC;EACnC,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB;;2CAEyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iDAAiD;EACjD,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,uCAAuC;EACvC,iDAAiD;EACjD,sCAAsC;EACtC,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf;;;;yCAIuC;AACzC;;AAEA;EACE,6CAA6C;EAC7C,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB;;2CAEyC;EACzC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA,oEAAoE;;AAEpE;EACE,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;;EAEE,iDAAiD;EACjD,6CAA6C;EAC7C,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,oEAAoE;;AAEpE;;EAEE,sBAAsB;EACtB,mCAAmC;EACnC,uCAAuC;EACvC,sEAAsE;EACtE,yCAAyC;EACzC,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,sEAAsE;EACtE,yCAAyC;EACzC,6CAA6C;EAC7C,uCAAuC;AACzC;;AAEA;;EAEE,sBAAsB;EACtB,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,sEAAsE;EACtE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;EACnC,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sEAAsE;EACtE,yCAAyC;EACzC,6CAA6C;EAC7C,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,sBAAsB;EACtB,kCAAkC;EAClC,mCAAmC;EACnC,uCAAuC;EACvC,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,mBAAmB;EACnB,oEAAoE;EACpE,wDAAwD;AAC1D;;AAEA;EACE,6CAA6C;EAC7C,oEAAoE;EACpE,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,gBAAgB;EAChB,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6CAA6C;EAC7C,gBAAgB;EAChB,oEAAoE;EACpE,iDAAiD;EACjD,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAAyD;EACzD,oDAAoD;EACpD,uCAAuC;EACvC,gCAAgC;EAChC,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,oEAAoE;EACpE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;EACjD,6CAA6C;EAC7C,gBAAgB;EAChB,oEAAoE;EACpE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,8CAA8C;EAC9C,6CAA6C;EAC7C,uCAAuC;EACvC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA,gDAAgD;AAChD;EACE,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA,oEAAoE;;AAEpE;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,iDAAiD;EACjD,kDAAkD;EAClD,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,oEAAoE;;AAEpE;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA,mEAAmE;;AAEnE;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,6CAA6C;EAC7C,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,sCAAsC;EACtC,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,gCAAgC;EAChC,sCAAsC;EACtC,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE;IACE,mDAAmD;IACnD,oEAAoE;IACpE,mBAAmB;EACrB;;EAEA;IACE,oEAAoE;IACpE,sCAAsC;EACxC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,iBAAiB;EACjB,wDAAwD;EACxD,kBAAkB;EAClB,+CAA+C;EAC/C,uCAAuC;EACvC,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,+CAA+C;AACjD","sourcesContent":["@import './cms-design-tokens.css';\r\n@import './cms-dialog.css';\r\n\r\nhtml,\r\nbody,\r\n#root {\r\n  margin: 0;\r\n  padding: 0;\r\n  height: 100%;\r\n  min-height: 100vh;\r\n}\r\n\r\nbody {\r\n  font-family: var(--cms-mfe-font-family);\r\n  font-size: var(--cms-mfe-font-size);\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.cms-mfe-root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 1;\r\n  min-height: 100vh;\r\n  height: 100%;\r\n  font-family: var(--cms-mfe-font-family);\r\n  font-size: var(--cms-mfe-font-size);\r\n  line-height: 1.45;\r\n  color: var(--cms-mfe-color-text);\r\n  background: var(--cms-mfe-color-surface-muted);\r\n}\r\n\r\n/* ── Shell layout ─────────────────────────────────────────────── */\r\n\r\n.cms-mfe-shell {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 100vh;\r\n  height: 100%;\r\n  gap: 0;\r\n  align-items: stretch;\r\n}\r\n\r\n.cms-mfe-shell__main {\r\n  flex: 1;\r\n  min-width: 0;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.cms-mfe-shell__outlet {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  padding: var(--cms-mfe-space-lg);\r\n  max-width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.cms-mfe-shell[data-cms-embedded='true'] .cms-mfe-shell__outlet {\r\n  padding: var(--cms-mfe-space-md) var(--cms-mfe-space-lg);\r\n}\r\n\r\n/* ── Sidebar navigation ───────────────────────────────────────── */\r\n\r\n.cms-mfe-shell-nav {\r\n  flex-shrink: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.cms-mfe-shell-nav--sidebar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: var(--cms-mfe-nav-width);\r\n  height: 100vh;\r\n  min-height: 100vh;\r\n  max-height: 100vh;\r\n  position: sticky;\r\n  top: 0;\r\n  align-self: flex-start;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  border-right: 1px solid var(--cms-mfe-color-border);\r\n  box-shadow: 1px 0 0 rgba(15, 23, 42, 0.04), 4px 0 16px rgba(15, 23, 42, 0.04);\r\n  transition: width var(--cms-mfe-nav-transition);\r\n}\r\n\r\n.cms-mfe-shell-nav--sidebar.cms-mfe-shell-nav--collapsed {\r\n  width: var(--cms-mfe-nav-width-collapsed);\r\n}\r\n\r\n.cms-mfe-shell-nav--tabs {\r\n  width: 100%;\r\n  height: auto;\r\n  min-height: 0;\r\n  max-height: none;\r\n  position: static;\r\n  border-right: none;\r\n  border-bottom: 1px solid var(--cms-mfe-color-border);\r\n  padding: 0 var(--cms-mfe-space-md);\r\n  box-shadow: var(--cms-mfe-shadow-nav);\r\n}\r\n\r\n.cms-mfe-shell[data-cms-embedded='true'] {\r\n  min-height: 100vh;\r\n}\r\n\r\n.cms-mfe-shell-nav__brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.625rem;\r\n  flex-shrink: 0;\r\n  padding: 1rem 1rem 0.875rem;\r\n  border-bottom: 1px solid var(--cms-mfe-color-border);\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  transition: padding var(--cms-mfe-nav-transition);\r\n}\r\n\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__brand {\r\n  justify-content: center;\r\n  padding-left: 0.625rem;\r\n  padding-right: 0.625rem;\r\n}\r\n\r\n.cms-mfe-shell-nav--tabs .cms-mfe-shell-nav__brand {\r\n  display: none;\r\n}\r\n\r\n.cms-mfe-shell-nav__brand-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2rem;\r\n  height: 2rem;\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n  background: linear-gradient(135deg, var(--cms-mfe-color-primary) 0%, var(--cms-mfe-color-accent) 100%);\r\n  color: var(--cms-mfe-color-text-inverse);\r\n  font-size: 0.9375rem;\r\n  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cms-mfe-shell-nav__brand-label {\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  letter-spacing: -0.02em;\r\n  color: var(--cms-mfe-color-text);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  transition:\r\n    opacity var(--cms-mfe-nav-transition),\r\n    max-width var(--cms-mfe-nav-transition);\r\n  max-width: 12rem;\r\n}\r\n\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__brand-label {\r\n  opacity: 0;\r\n  max-width: 0;\r\n}\r\n\r\n.cms-mfe-shell-nav__list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0.625rem 0.5rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--cms-mfe-color-border-strong) transparent;\r\n}\r\n\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__list {\r\n  padding-left: 0.375rem;\r\n  padding-right: 0.375rem;\r\n}\r\n\r\n.cms-mfe-shell-nav__list::-webkit-scrollbar {\r\n  width: 4px;\r\n}\r\n\r\n.cms-mfe-shell-nav__list::-webkit-scrollbar-thumb {\r\n  background: var(--cms-mfe-color-border-strong);\r\n  border-radius: 4px;\r\n}\r\n\r\n.cms-mfe-shell-nav--tabs .cms-mfe-shell-nav__list {\r\n  flex: initial;\r\n  flex-direction: row;\r\n  gap: 0;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n  padding: 0;\r\n}\r\n\r\n.cms-mfe-shell-nav__item {\r\n  margin: 0;\r\n}\r\n\r\n.cms-mfe-shell-nav__link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.625rem;\r\n  padding: 0.625rem 0.75rem;\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n  color: var(--cms-mfe-color-text-muted);\r\n  text-decoration: none;\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  border-left: 3px solid transparent;\r\n  transition:\r\n    background var(--cms-mfe-transition),\r\n    color var(--cms-mfe-transition),\r\n    border-color var(--cms-mfe-transition),\r\n    padding var(--cms-mfe-nav-transition);\r\n  white-space: nowrap;\r\n}\r\n\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__link {\r\n  justify-content: center;\r\n  gap: 0;\r\n  padding: 0.625rem 0.5rem;\r\n  border-left-color: transparent;\r\n}\r\n\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__link--active,\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__link.cms-mfe-shell-nav__link--active {\r\n  border-left-color: transparent;\r\n  box-shadow: inset 3px 0 0 var(--cms-mfe-color-primary);\r\n}\r\n\r\n.cms-mfe-shell-nav--tabs .cms-mfe-shell-nav__link {\r\n  border-radius: 0;\r\n  border-left: none;\r\n  border-bottom: 2px solid transparent;\r\n  padding: 0.5rem 0.75rem;\r\n}\r\n\r\n.cms-mfe-shell-nav__link:hover {\r\n  background: var(--cms-mfe-color-primary-soft);\r\n  color: var(--cms-mfe-color-primary);\r\n}\r\n\r\n.cms-mfe-shell-nav__link--active,\r\n.cms-mfe-shell-nav__link.cms-mfe-shell-nav__link--active {\r\n  background: var(--cms-mfe-color-primary-soft);\r\n  color: var(--cms-mfe-color-primary);\r\n  border-left-color: var(--cms-mfe-color-primary);\r\n  font-weight: 600;\r\n}\r\n\r\n.cms-mfe-shell-nav--tabs .cms-mfe-shell-nav__link--active {\r\n  background: transparent;\r\n  border-left-color: transparent;\r\n  border-bottom-color: var(--cms-mfe-color-primary);\r\n}\r\n\r\n.cms-mfe-shell-nav__link-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.375rem;\r\n  font-size: 0.9375rem;\r\n  opacity: 0.9;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cms-mfe-shell-nav__link--active .cms-mfe-shell-nav__link-icon {\r\n  opacity: 1;\r\n}\r\n\r\n.cms-mfe-shell-nav__link-label {\r\n  line-height: 1.25;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  transition:\r\n    opacity var(--cms-mfe-nav-transition),\r\n    max-width var(--cms-mfe-nav-transition);\r\n  max-width: 12rem;\r\n}\r\n\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__link-label {\r\n  opacity: 0;\r\n  max-width: 0;\r\n}\r\n\r\n.cms-mfe-shell-nav__footer {\r\n  flex-shrink: 0;\r\n  padding: 0.5rem;\r\n  border-top: 1px solid var(--cms-mfe-color-border);\r\n  background: var(--cms-mfe-color-surface-muted);\r\n}\r\n\r\n.cms-mfe-shell-nav__toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n  width: 100%;\r\n  min-height: 2.25rem;\r\n  padding: 0.5rem 0.75rem;\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  color: var(--cms-mfe-color-text-muted);\r\n  font-family: inherit;\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition:\r\n    background var(--cms-mfe-transition),\r\n    color var(--cms-mfe-transition),\r\n    border-color var(--cms-mfe-transition),\r\n    padding var(--cms-mfe-nav-transition);\r\n}\r\n\r\n.cms-mfe-shell-nav__toggle:hover {\r\n  background: var(--cms-mfe-color-primary-soft);\r\n  color: var(--cms-mfe-color-primary);\r\n  border-color: rgba(59, 130, 246, 0.25);\r\n}\r\n\r\n.cms-mfe-shell-nav__toggle-icon {\r\n  font-size: 0.875rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cms-mfe-shell-nav__toggle-label {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  transition:\r\n    opacity var(--cms-mfe-nav-transition),\r\n    max-width var(--cms-mfe-nav-transition);\r\n  max-width: 8rem;\r\n}\r\n\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__toggle {\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n}\r\n\r\n.cms-mfe-shell-nav--collapsed .cms-mfe-shell-nav__toggle-label {\r\n  opacity: 0;\r\n  max-width: 0;\r\n}\r\n\r\n/* ── PrimeReact — compact density ─────────────────────────────── */\r\n\r\n.cms-mfe-root .p-breadcrumb {\r\n  background: transparent;\r\n  border: none;\r\n  padding: 0 0 var(--cms-mfe-space-md);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-breadcrumb .p-menuitem-link {\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n  padding: 0.2rem 0.35rem;\r\n}\r\n\r\n.cms-mfe-root .p-panel,\r\n.cms-mfe-root .cms-mfe-content-card {\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  border-radius: var(--cms-mfe-radius-md);\r\n  box-shadow: var(--cms-mfe-shadow-card);\r\n}\r\n\r\n.cms-mfe-root .p-button {\r\n  padding: 0.3125rem 0.625rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  font-weight: 500;\r\n  line-height: 1.25;\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n}\r\n\r\n.cms-mfe-root .p-button .p-button-icon {\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n.cms-mfe-root .p-button.p-button-icon-only {\r\n  width: var(--cms-mfe-control-height-sm);\r\n  height: var(--cms-mfe-control-height-sm);\r\n  padding: 0;\r\n}\r\n\r\n.cms-mfe-root .p-button.p-button-sm {\r\n  padding: 0.25rem 0.5rem;\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n}\r\n\r\n.cms-mfe-root .p-button.p-button-sm.p-button-icon-only {\r\n  width: 1.625rem;\r\n  height: 1.625rem;\r\n}\r\n\r\n/* ── Form controls — unified input / dropdown / calendar height ─ */\r\n\r\n.cms-mfe-root .p-inputtext,\r\n.cms-mfe-root .p-inputnumber-input {\r\n  box-sizing: border-box;\r\n  height: var(--cms-mfe-input-height);\r\n  min-height: var(--cms-mfe-input-height);\r\n  padding: var(--cms-mfe-input-padding-y) var(--cms-mfe-input-padding-x);\r\n  font-size: var(--cms-mfe-input-font-size);\r\n  line-height: var(--cms-mfe-input-line-height);\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n}\r\n\r\n.cms-mfe-root .p-inputtextarea {\r\n  box-sizing: border-box;\r\n  padding: var(--cms-mfe-input-padding-y) var(--cms-mfe-input-padding-x);\r\n  font-size: var(--cms-mfe-input-font-size);\r\n  line-height: var(--cms-mfe-input-line-height);\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n}\r\n\r\n.cms-mfe-root .p-dropdown,\r\n.cms-mfe-root .p-multiselect {\r\n  box-sizing: border-box;\r\n  height: var(--cms-mfe-input-height);\r\n  min-height: var(--cms-mfe-input-height);\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n  align-items: stretch;\r\n}\r\n\r\n.cms-mfe-root .p-dropdown .p-dropdown-label,\r\n.cms-mfe-root .p-multiselect .p-multiselect-label {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  height: 100%;\r\n  min-height: 0;\r\n  padding: var(--cms-mfe-input-padding-y) var(--cms-mfe-input-padding-x);\r\n  font-size: var(--cms-mfe-input-font-size);\r\n  line-height: var(--cms-mfe-input-line-height);\r\n}\r\n\r\n.cms-mfe-root .p-dropdown .p-dropdown-label.p-placeholder,\r\n.cms-mfe-root .p-multiselect .p-multiselect-label.p-placeholder {\r\n  color: var(--cms-mfe-color-text-muted);\r\n}\r\n\r\n.cms-mfe-root .p-dropdown .p-dropdown-trigger,\r\n.cms-mfe-root .p-multiselect .p-multiselect-trigger {\r\n  width: var(--cms-mfe-input-height);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.cms-mfe-root .p-dropdown .p-dropdown-trigger .p-dropdown-trigger-icon,\r\n.cms-mfe-root .p-multiselect .p-multiselect-trigger .p-multiselect-trigger-icon {\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.cms-mfe-root .p-multiselect .p-multiselect-token {\r\n  padding: 0.125rem 0.375rem;\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  margin-right: 0.25rem;\r\n}\r\n\r\n.cms-mfe-root .p-calendar {\r\n  display: inline-flex;\r\n  width: 100%;\r\n  max-width: 100%;\r\n}\r\n\r\n.cms-mfe-root .p-calendar.p-inputwrapper,\r\n.cms-mfe-root .p-calendar-w-btn {\r\n  height: var(--cms-mfe-input-height);\r\n  min-height: var(--cms-mfe-input-height);\r\n  align-items: stretch;\r\n}\r\n\r\n.cms-mfe-root .p-calendar .p-inputtext {\r\n  box-sizing: border-box;\r\n  flex: 1 1 auto;\r\n  width: 1%;\r\n  height: 100%;\r\n  min-height: 0;\r\n  padding: var(--cms-mfe-input-padding-y) var(--cms-mfe-input-padding-x);\r\n  font-size: var(--cms-mfe-input-font-size);\r\n  line-height: var(--cms-mfe-input-line-height);\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.cms-mfe-root .p-calendar .p-datepicker-trigger,\r\n.cms-mfe-root .p-calendar .p-button.p-datepicker-trigger {\r\n  box-sizing: border-box;\r\n  width: var(--cms-mfe-input-height);\r\n  height: var(--cms-mfe-input-height);\r\n  min-height: var(--cms-mfe-input-height);\r\n  padding: 0;\r\n  flex-shrink: 0;\r\n  border-top-left-radius: 0;\r\n  border-bottom-left-radius: 0;\r\n}\r\n\r\n.cms-mfe-root .p-calendar .p-datepicker-trigger .p-button-icon,\r\n.cms-mfe-root .p-calendar .p-button.p-datepicker-trigger .p-button-icon {\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n.cms-mfe-root .p-calendar:not(.p-calendar-w-btn) .p-inputtext {\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n}\r\n\r\n.cms-mfe-root .p-field .p-dropdown,\r\n.cms-mfe-root .p-field .p-multiselect,\r\n.cms-mfe-root .p-field .p-calendar,\r\n.cms-mfe-root .p-field .p-inputtext {\r\n  width: 100%;\r\n}\r\n\r\n.cms-mfe-root .w-full.p-dropdown,\r\n.cms-mfe-root .w-full.p-multiselect,\r\n.cms-mfe-root .w-full.p-calendar,\r\n.cms-mfe-root .w-full.p-inputtext {\r\n  width: 100%;\r\n}\r\n\r\n.cms-mfe-root .p-datatable {\r\n  border-radius: var(--cms-mfe-radius-md);\r\n  overflow: hidden;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-datatable .p-datatable-header {\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  border-bottom: none;\r\n  border-radius: var(--cms-mfe-radius-md) var(--cms-mfe-radius-md) 0 0;\r\n  padding: var(--cms-mfe-space-md) var(--cms-mfe-space-lg);\r\n}\r\n\r\n.cms-mfe-root .p-datatable .p-datatable-wrapper {\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  border-radius: 0 0 var(--cms-mfe-radius-md) var(--cms-mfe-radius-md);\r\n  overflow: hidden;\r\n}\r\n\r\n.cms-mfe-root .p-datatable .p-datatable-thead > tr > th {\r\n  background: var(--cms-mfe-color-surface-muted);\r\n  color: var(--cms-mfe-color-text-muted);\r\n  font-weight: 600;\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  border-color: var(--cms-mfe-color-border);\r\n  padding: 0.4375rem 0.625rem;\r\n}\r\n\r\n.cms-mfe-root .p-datatable .p-datatable-tbody > tr {\r\n  transition: background var(--cms-mfe-transition);\r\n}\r\n\r\n.cms-mfe-root .p-datatable .p-datatable-tbody > tr:hover {\r\n  background: var(--cms-mfe-color-primary-soft);\r\n}\r\n\r\n.cms-mfe-root .p-datatable .p-datatable-tbody > tr > td {\r\n  border-color: var(--cms-mfe-color-border);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  padding: 0.4375rem 0.625rem;\r\n  vertical-align: middle;\r\n}\r\n\r\n.cms-mfe-root .p-datatable .p-datatable-tbody > tr:nth-child(even) {\r\n  background: rgba(248, 250, 252, 0.6);\r\n}\r\n\r\n.cms-mfe-root .p-datatable .p-sortable-column .p-sortable-column-icon {\r\n  font-size: 0.6875rem;\r\n}\r\n\r\n.cms-mfe-root .p-paginator {\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  border-top: none;\r\n  border-radius: 0 0 var(--cms-mfe-radius-md) var(--cms-mfe-radius-md);\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  padding: 0.25rem 0.375rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-paginator .p-paginator-element,\r\n.cms-mfe-root .p-paginator .p-paginator-pages .p-paginator-page {\r\n  min-width: 1.625rem;\r\n  height: 1.625rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-paginator .p-dropdown {\r\n  height: 1.625rem;\r\n  min-height: 1.625rem;\r\n}\r\n\r\n.cms-mfe-root .p-paginator .p-dropdown .p-dropdown-label {\r\n  padding: 0.125rem 0.375rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-paginator .p-dropdown .p-dropdown-trigger {\r\n  width: 1.625rem;\r\n}\r\n\r\n.cms-mfe-root .p-tag {\r\n  border-radius: 999px;\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  font-weight: 600;\r\n  letter-spacing: 0.02em;\r\n  padding: 0.125rem 0.4375rem;\r\n}\r\n\r\n.cms-mfe-root .group-header {\r\n  margin: var(--cms-mfe-space-md) 0 var(--cms-mfe-space-sm);\r\n  border-bottom: 1px solid var(--cms-mfe-color-border);\r\n  padding-bottom: var(--cms-mfe-space-xs);\r\n  color: var(--cms-mfe-color-text);\r\n  font-weight: 600;\r\n  font-size: var(--cms-mfe-font-size);\r\n}\r\n\r\n.cms-mfe-root .p-field {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.cms-mfe-root .p-field > label,\r\n.cms-mfe-root label {\r\n  display: block;\r\n  margin-bottom: var(--cms-mfe-space-xs);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  font-weight: 500;\r\n  color: var(--cms-mfe-color-text-muted);\r\n}\r\n\r\n.cms-mfe-root .p-tabview .p-tabview-nav li .p-tabview-nav-link {\r\n  padding: 0.5rem 0.75rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-tabview .p-tabview-nav {\r\n  border-radius: var(--cms-mfe-radius-md) var(--cms-mfe-radius-md) 0 0;\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n}\r\n\r\n.cms-mfe-root .p-tabview .p-tabview-panels {\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  border-top: none;\r\n  border-radius: 0 0 var(--cms-mfe-radius-md) var(--cms-mfe-radius-md);\r\n  padding: var(--cms-mfe-space-md);\r\n}\r\n\r\n.cms-mfe-root .p-accordion .p-accordion-header .p-accordion-header-link {\r\n  padding: 0.5rem 0.75rem;\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-accordion .p-accordion-content {\r\n  padding: var(--cms-mfe-space-md);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-card {\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-card .p-card-body {\r\n  padding: var(--cms-mfe-space-md);\r\n}\r\n\r\n.cms-mfe-root .p-card .p-card-title {\r\n  font-size: var(--cms-mfe-font-size);\r\n  margin-bottom: var(--cms-mfe-space-sm);\r\n}\r\n\r\n.cms-mfe-root .p-skeleton {\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n}\r\n\r\n.cms-mfe-root .p-tooltip .p-tooltip-text {\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  padding: 0.25rem 0.4375rem;\r\n}\r\n\r\n.cms-mfe-root .p-confirm-popup {\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-mfe-root .p-confirm-popup .p-confirm-popup-footer .p-button {\r\n  padding: 0.25rem 0.5rem;\r\n}\r\n\r\n/* Advanced search panels */\r\n.cms-mfe-root .cms-mfe-advanced-search {\r\n  background: var(--cms-mfe-color-surface-muted);\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  border-radius: var(--cms-mfe-radius-md);\r\n  padding: var(--cms-mfe-space-md);\r\n  margin-top: var(--cms-mfe-space-md);\r\n}\r\n\r\n/* PrimeFlex grid inside CMS — tighter gutters */\r\n.cms-mfe-root .grid {\r\n  margin-right: -0.25rem;\r\n  margin-left: -0.25rem;\r\n  margin-top: -0.25rem;\r\n}\r\n\r\n.cms-mfe-root .grid > [class*='col'] {\r\n  padding: 0.25rem;\r\n}\r\n\r\n.cms-mfe-providers-body {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  min-height: 0;\r\n  height: 100%;\r\n}\r\n\r\n/* ── Toast ────────────────────────────────────────────────────── */\r\n\r\n.cms-mfe-toast-host.p-toast {\r\n  width: min(24rem, calc(100vw - 1.5rem));\r\n  max-width: 100%;\r\n}\r\n\r\n.cms-mfe-toast-host .p-toast-message {\r\n  margin: 0 0 0.5rem;\r\n  border-radius: var(--cms-mfe-radius-sm);\r\n  box-shadow: var(--cms-mfe-shadow-md);\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.cms-mfe-toast-host .p-toast-message-error {\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  border-left: 3px solid var(--cms-mfe-color-danger);\r\n  outline: none;\r\n}\r\n\r\n.cms-mfe-toast-host .p-toast-message-error .p-toast-summary {\r\n  font-weight: 600;\r\n  font-size: var(--cms-mfe-font-size);\r\n  color: var(--cms-mfe-color-text);\r\n}\r\n\r\n.cms-mfe-toast-host .p-toast-message-error .p-toast-detail {\r\n  color: var(--cms-mfe-color-text-muted);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  margin-top: 0.25rem;\r\n  line-height: 1.4;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.cms-mfe-toast-host .p-toast-icon-close:hover {\r\n  background: var(--cms-mfe-color-primary-soft);\r\n}\r\n\r\n/* ── Standalone / iframe roots ────────────────────────────────── */\r\n\r\n.cms-mfe-standalone-root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n  background: var(--cms-mfe-color-surface-muted, #f4f6f9);\r\n}\r\n\r\n.cms-mfe-iframe-root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  height: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.cms-mfe-iframe-root > *,\r\n.cms-mfe-standalone-root > * {\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* ── Detail field pairs (OutPutPair) ─────────────────────────── */\r\n\r\n.cms-mfe-root .cms-output-pair__label-col,\r\n.cms-mfe-root .cms-output-pair__value-col {\r\n  min-width: 0;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.cms-mfe-root .cms-output-pair__label,\r\n.cms-mfe-root .cms-output-pair__value {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  min-height: 1.625rem;\r\n  padding: 0.25rem 0.5rem;\r\n  line-height: 1.3;\r\n  border: 1px solid var(--cms-mfe-color-border);\r\n  min-width: 0;\r\n}\r\n\r\n.cms-mfe-root .cms-output-pair__label {\r\n  height: 100%;\r\n  background: var(--cms-mfe-color-surface-muted);\r\n  color: var(--cms-mfe-color-text-muted);\r\n  font-size: var(--cms-mfe-font-size-xs);\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.03em;\r\n  border-radius: var(--cms-mfe-radius-sm) 0 0 var(--cms-mfe-radius-sm);\r\n  border-right: none;\r\n}\r\n\r\n.cms-mfe-root .cms-output-pair__value {\r\n  height: 100%;\r\n  background: var(--cms-mfe-color-surface-elevated);\r\n  color: var(--cms-mfe-color-text);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  word-break: break-word;\r\n  border-radius: 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0;\r\n}\r\n\r\n.cms-mfe-root .cms-output-pair__value--empty {\r\n  color: var(--cms-mfe-color-text-muted);\r\n}\r\n\r\n.cms-mfe-root .cms-output-pair__value--custom {\r\n  padding-top: 0.125rem;\r\n  padding-bottom: 0.125rem;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .cms-mfe-root .cms-output-pair__label {\r\n    border-right: 1px solid var(--cms-mfe-color-border);\r\n    border-radius: var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm) 0 0;\r\n    border-bottom: none;\r\n  }\r\n\r\n  .cms-mfe-root .cms-output-pair__value {\r\n    border-radius: 0 0 var(--cms-mfe-radius-sm) var(--cms-mfe-radius-sm);\r\n    margin-bottom: var(--cms-mfe-space-xs);\r\n  }\r\n}\r\n\r\n.cms-iframe-shell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 1;\r\n  min-height: 100vh;\r\n  padding: var(--cms-mfe-space-xl) var(--cms-mfe-space-lg);\r\n  text-align: center;\r\n  color: var(--cms-mfe-color-text-muted, #64748b);\r\n  font-family: var(--cms-mfe-font-family);\r\n  gap: var(--cms-mfe-space-md);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n}\r\n\r\n.cms-iframe-shell__spinner {\r\n  font-size: 1.5rem;\r\n  color: var(--cms-mfe-color-primary, #3b82f6);\r\n}\r\n\r\n.cms-iframe-shell--error {\r\n  color: var(--cms-mfe-color-danger, #dc2626);\r\n}\r\n\r\n.cms-iframe-shell__hint {\r\n  margin-top: var(--cms-mfe-space-sm);\r\n  font-size: var(--cms-mfe-font-size-sm);\r\n  color: var(--cms-mfe-color-text-muted, #94a3b8);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
